"use client";

import { useTenant } from "@tillix/tenants/react";
import { BaseCheckbox, type BaseCheckboxProps } from "./checkbox";
import ConEdisonCheckbox from "./checkbox.con-edison";

export function Checkbox(props: BaseCheckboxProps) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant?.id ?? contextTenant?.id;

  switch (tenantRefId) {
    case "con-edison":
      return <ConEdisonCheckbox {...props} />;

    default:
      return <BaseCheckbox {...props} />;
  }
}
